import Vue from 'vue'

export function configField(key) {
  return {
    get() {
      const config = (this.posConfig && this.posConfig.config) || {}
      const value = config[key]
      return value === null || value === undefined ? '' : value
    },
    set(value) {
      if (!this.posConfig.config) {
        Vue.set(this.posConfig, 'config', {})
      }
      Vue.set(this.posConfig.config, key, value)
    },
  }
}
